import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { Button, Modal } from '@shared/widgets';

interface IBeforeRegisterModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const BeforeRegisterModal = (props: IBeforeRegisterModalProps) => {
  const { navigate } = useRouteHook();

  const openMasterKeyHandler = () => {
    props.onClose();
    navigate(RoutePaths.masterKey.onNavigate());
  };

  return (
    <Modal title='Before we get started' isOpen={props.isOpen} onClose={props.onClose}>
      <p className='max-md:text-[#4c4c4c80]'>
        To register for Insignia's Online Network, you need to download and activate the secure Master Key App. If you need any assistance please
        contact our customer services team on the number below:
      </p>
      <div className='mt-4 mb-8 max-md:mx-6 max-md:mt-4 max-md:rounded-lg max-md:bg-[#d7c29a1a] max-md:p-2'>
        <p className='text-[#000]'>24-hour phone support:</p>
        <p className='text-[#000]'>+44-203-151-7000 / +800-800-00-700</p>
      </div>
      <Button className='mx-auto w-[159px] max-md:w-full' onClick={openMasterKeyHandler}>
        Download Now
      </Button>
    </Modal>
  );
};
